module.exports = __webpack_public_path__ + "img/WN.ec20f430.svg";